import React from 'react';

import { SubHeading, MenuItem } from '../../Components';
import { data, images } from '../../constants';
import './SpecialMenu.css';

const SpecialMenu = () => (
<div className="app__specialMenu flex__center section__padding" id="menu">
      <div className="app__specialMenu-title" data-aos="fade-down">
        <SubHeading title="A Menu of Unparalleled Elegance" />
        <h1 className="headtext__cormorant">Beverages</h1>
      </div>

      <div className="app__specialMenu-menu">
        <div className="app__specialMenu-menu_wine flex__center" data-aos="fade-right">
          <p className="app__specialMenu-menu_heading">Wine & Beer</p>
          <div className="app__specialMenu_menu_items">
            {data.wines.map((wine, index) => (
              <MenuItem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
            ))}
          </div>
        </div>

        <div className="app__specialMenu-menu_img" data-aos="zoom-in">
          <img src={images.menu} alt="menu__img" />
        </div>

        <div className="app__specialMenu-menu_cocktails flex__center" data-aos="fade-left">
          <p className="app__specialMenu-menu_heading">Cocktails</p>
          <div className="app__specialMenu_menu_items">
            {data.cocktails.map((cocktail, index) => (
              <MenuItem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags} />
            ))}
          </div>
        </div>
      </div>

      <div className="app__specialMenus-title" data-aos="fade-down">
        <h1 className="headtext__cormorant">Cuisine</h1>
      </div>

      <div className="app__specialMenu-menus">
        <div className="app__specialMenu-menu_wine flex__center" data-aos="fade-right">
          <p className="app__specialMenu-menu_heading">Entrees</p>
          <div className="app__specialMenu_menu_items">
            {data.entrees.map((entrees, index) => (
              <MenuItem key={entrees.title + index} title={entrees.title} price={entrees.price} tags={entrees.tags} />
            ))}
          </div>
        </div>

        <div className="app__specialMenu-menu_img" data-aos="zoom-in">
          <img src={images.menu2} alt="menu__img" />
        </div>

        <div className="app__specialMenu-menu_wine flex__center" data-aos="fade-left">
          <p className="app__specialMenu-menu_heading">Mains</p>
          <div className="app__specialMenu_menu_items">
            {data.mains.map((mains, index) => (
              <MenuItem key={mains.title + index} title={mains.title} price={mains.price} tags={mains.tags} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );

export default SpecialMenu;